import { Badge } from "@/components/ui/badge";
import { SelectionGrid, type SelectionGridItem } from "../shared/components";

export type McpTool = {
  name: string;
  description?: string;
  input_schema?: unknown;
  inputSchema?: unknown;
};

export interface ToolSelectorProps {
  tools: McpTool[] | null;
  selectedTool: string | null;
  onToolSelect: (toolName: string) => void;
  isLoading: boolean;
  error: Error | null;
}

export function ToolSelector({
  tools,
  selectedTool,
  onToolSelect,
  isLoading,
  error,
}: ToolSelectorProps) {
  return (
    <SelectionGrid
      items={(tools as SelectionGridItem[]) || []}
      selectedItem={selectedTool}
      onItemSelect={onToolSelect}
      isLoading={isLoading}
      error={error?.message || null}
      emptyMessage="No tools available"
      errorMessage="Failed to load tools"
      renderItemContent={(item) => {
        const tool = item as unknown as McpTool;
        const schema = tool.inputSchema || tool.input_schema;
        const schemaObj = schema as {
          properties?: Record<string, unknown>;
          required?: string[];
        };

        return (
          <>
            <div className="font-semibold text-foreground group-hover:text-primary transition-colors">
              {tool.name}
            </div>
            <div className="text-sm text-muted-foreground mt-1 line-clamp-2">
              {tool.description || "No description provided"}
            </div>
            {schemaObj?.properties &&
              Object.keys(schemaObj.properties).length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {Object.entries(schemaObj.properties).map(([paramName]) => (
                    <Badge
                      key={paramName}
                      variant="outline"
                      className="text-xs"
                    >
                      {paramName}
                      {schemaObj.required?.includes(paramName) && (
                        <span className="text-destructive ml-1">*</span>
                      )}
                    </Badge>
                  ))}
                </div>
              )}
          </>
        );
      }}
    />
  );
}
